import { useContext } from 'react'
import ResultItem from './ResultItem'
import { motion, AnimatePresence } from 'framer-motion'
import ResultContext from '../context/ResultContext'
import '../components/assets/loading-bar.gif'
import Spinner from '../components/Spinner'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

function ResultList() {
  const { inventory, isLoading } = useContext(ResultContext)

  if (!isLoading && (!inventory || inventory.length === 0)) {
    return (
      <p className='text-center text-xl font-medium'>
        Nothing in Inventory yet!!!
      </p>
    )
  }

  return isLoading ? (
    <Spinner />
  ) : (
    <div className='grid grid-cols-2 2xl:grid-cols-8 xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-4 md:p-2 md:gap-1 md:m-1 2xl:gap-2'>
      <AnimatePresence>
        {inventory.map((item) => (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <ResultItem key={item.id} item={item} />
          </motion.div>
        ))}
      </AnimatePresence>
      <ToastContainer />
    </div>
  )

  // return (
  //   <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
  //     {inventory.map((item) => (
  //       <ResultItem key={item.id} item={item} handleDelete={handleDelete} />
  //     ))}
  //   </div>
  // )
}

export default ResultList
